import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Root } from "./pages/Root";

import "primereact/resources/themes/saga-blue/theme.css";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/app-privacy-policy/:appKey" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
